import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { FormattedMessage as T } from "react-intl";
import { ValidateCourseNumberResponse } from "services/KnowfullyAdminClient";

const getStyles = () => ({
  courseNumberList: {
    mt: 2,
  },
  courseNumberItem: {
    ml: 2,
    mt: 1,
  },
  proceedQuestion: {
    mt: 3,
  },
  error: {
    width: "100%",
    mt: 2,
  },
});

interface InternalValidationDialogProps {
  open: boolean;
  productName: string;
  courseNumberBeingCreated: string;
  validationData: ValidateCourseNumberResponse;
  loading?: boolean;
  error?: string | null;
  onProceed: () => void;
  onCancel: () => void;
}

export const InternalValidationDialog = ({
  open,
  productName,
  courseNumberBeingCreated,
  validationData,
  loading,
  error,
  onProceed,
  onCancel,
}: InternalValidationDialogProps) => {
  const styles = getStyles();

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>
        <T id="internalValidationDialogTitle" values={{ productName }} />
      </DialogTitle>
      <DialogContent dividers>
        <Typography gutterBottom>
          <T
            id="internalValidationDialogMessage"
            values={{
              courseNumber: courseNumberBeingCreated,
            }}
          />
        </Typography>

        <Box sx={styles.courseNumberList}>
          <Typography gutterBottom>
            <T id="internalValidationDialogCourseNumbersInOtherSkus" />
          </Typography>
          {validationData.existingSkuCourseNumbers?.map((skuGroup, idx) => (
            <Typography
              key={skuGroup.sku! + idx}
              sx={styles.courseNumberItem}
            >
              {skuGroup.sku}: {skuGroup.courseNumbers?.join(", ")}
            </Typography>
          ))}
        </Box>

        <Typography sx={styles.proceedQuestion}>
          <T id="internalValidationDialogProceedQuestion" />
        </Typography>

        {error && (
          <Alert sx={styles.error} severity="error">
            {error}
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="primary" disabled={loading}>
          <T id="cancelButton" />
        </Button>
        <Button
          onClick={onProceed}
          color="primary"
          disabled={loading}
          startIcon={loading && <CircularProgress size={16} />}
        >
          <T id="yes" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};
